<div class="signup-page">
  <div class="signup-card">
    <!-- HEADER -->
    <div class="signup-header">
      <img src="Logo/logo-opt.webp" class="logo" alt="Logo" />

      <button class="close-btn" type="button" (click)="closeSignup()">×</button>
    </div>

    <!-- TITLE -->
    <h2 class="title">JOIN CASINOZE</h2>
    <p class="subtitle">Create your free account and start playing.</p>

    <!-- FORM -->
    <form
      class="form"
      [formGroup]="signupForm"
      (ngSubmit)="createUser()"
      novalidate
    >
      <!-- NAME -->
      <div class="row">
        <input
          type="text"
          class="input"
          placeholder="First Name"
          formControlName="firstName"
        />

        <input
          type="text"
          class="input"
          placeholder="Last Name"
          formControlName="lastName"
        />
      </div>

      <!-- USERNAME -->
      <div class="input-group">
        <span class="icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5z"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M4 20c0-3.3 3.6-6 8-6s8 2.7 8 6"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </span>

        <input
          type="text"
          class="input"
          placeholder="Username"
          formControlName="username"
          (input)="restrictWhiteSpaces()"
        />
      </div>

      <!-- REFERRAL -->
      <div class="input-group">
        <span class="icon">
          <svg viewBox="0 0 24 24" fill="none">
            <rect
              x="3"
              y="8"
              width="18"
              height="13"
              rx="2"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M12 8v13M3 12h18"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M7 8a2 2 0 114 0M13 8a2 2 0 114 0"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </span>

        <input
          type="text"
          class="input"
          placeholder="Referral Code (Optional)"
          formControlName="referralCode"
        />
      </div>

      <!-- EMAIL -->
      <div class="input-group">
        <span class="icon">
          <svg viewBox="0 0 24 24" fill="none">
            <rect
              x="3"
              y="5"
              width="18"
              height="14"
              rx="2"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path d="M3 7l9 6 9-6" stroke="currentColor" stroke-width="1.5" />
          </svg>
        </span>

        <input
          type="email"
          class="input"
          placeholder="Email Address"
          formControlName="email"
        />
      </div>

      <!-- PASSWORD -->
      <div class="input-group">
        <span class="icon">
          <svg viewBox="0 0 24 24" fill="none">
            <rect
              x="5"
              y="11"
              width="14"
              height="10"
              rx="2"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M8 11V7a4 4 0 118 0v4"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </span>

        <input
          [type]="showpassword ? 'text' : 'password'"
          class="input"
          placeholder="Password (8+ chars)"
          formControlName="password"
          (focus)="isPasswordFocused = true"
          (blur)="isPasswordFocused = false"
          (input)="checkPasswordStrength()"
        />

        <span class="eye" (click)="togglePassword()">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <circle
              cx="12"
              cy="12"
              r="3"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </span>
      </div>

      <!-- CONFIRM PASSWORD -->
      <div class="input-group">
        <span class="icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 3l7 3v6c0 5-3.5 8-7 9-3.5-1-7-4-7-9V6l7-3z"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </span>

        <input
          [type]="Confirmshowpassword ? 'text' : 'password'"
          class="input"
          placeholder="Confirm Password"
          formControlName="confirmPassword"
        />

        <span class="eye" (click)="toggleConfirmPassword()">
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <circle
              cx="12"
              cy="12"
              r="3"
              stroke="currentColor"
              stroke-width="1.5"
            />
          </svg>
        </span>
      </div>

      <!-- SUBMIT -->
      <button type="submit" class="primary-btn">CREATE ACCOUNT →</button>

      <!-- DIVIDER -->
      <div class="divider">
        <span>OR</span>
      </div>

      <!-- GOOGLE -->
      <button type="button" class="google-btn" (click)="continueWithGoogle()">
        <svg class="google-icon" viewBox="0 0 48 48">
          <path
            fill="#EA4335"
            d="M24 9.5c3.54 0 6.69 1.22 9.19 3.61l6.85-6.85C35.9 2.54 30.37 0 24 0 14.61 0 6.36 5.44 2.44 13.32l7.98 6.2C12.26 13.39 17.68 9.5 24 9.5z"
          />

          <path
            fill="#4285F4"
            d="M46.5 24.5c0-1.63-.15-3.2-.42-4.7H24v9h12.7c-.55 2.9-2.17 5.36-4.62 7.01l7.2 5.6c4.2-3.87 6.62-9.58 6.62-16.91z"
          />

          <path
            fill="#FBBC05"
            d="M10.42 28.52A14.5 14.5 0 019.5 24c0-1.57.27-3.09.76-4.52l-7.98-6.2A23.93 23.93 0 000 24c0 3.87.92 7.53 2.56 10.68l7.86-6.16z"
          />

          <path
            fill="#34A853"
            d="M24 48c6.48 0 11.92-2.14 15.9-5.8l-7.2-5.6c-2 1.35-4.56 2.15-8.7 2.15-6.32 0-11.74-3.89-13.58-9.52l-7.86 6.16C6.36 42.56 14.61 48 24 48z"
          />
        </svg>

        Continue with Google
      </button>
    </form>

    <!-- FOOTER -->
    <p class="footer">
      Already have an account?

      <a href="#" class="signin-link" (click)="openLoginPopup($event)">
        Sign In →
      </a>
    </p>
  </div>
</div>
